import split from '@/lib/split'
import marketing from '@/lib/marketing'
import type { NavigationGuard } from 'vue-router'

/**
 * Shared initialization tasks
 * These will be run only once on app entry
 *
 * @param afterNext Fn to run alongside setup tasks, to be run only once on app entry. Run after the next cb is called
 * @returns A navigation guard function
 */
export const AppSetupBeforeEnter = () => {
  performance.mark('start_app_before_enter')
  let initialized = false
  return ((_to, _from, next) => {
    next()
    if (!initialized) {
      split.initialize()
      marketing.initialize(window.environment)
      initialized = true
    }
    performance.mark('end_app_before_enter')
    performance.measure(
      'app_before_enter',
      'start_app_before_enter',
      'end_app_before_enter'
    )
  }) satisfies NavigationGuard
}
